import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapsLoaderService {
  private readonly apiKey = 'AIzaSyD12Hu8RxLmdBfjtyK1lyZDFsH1QBXWiHw';
  private isLoaded = false;

  load(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.isLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.isLoaded = true;
        resolve();
      };

      script.onerror = () => {
        reject(new Error('No se pudo cargar Google Maps.'));
      };

      document.head.appendChild(script);
    });
  }
}
